import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useRootStore } from '../../../../providers/root-store-provider';
import { BaseDialog } from '../base-dialog';
import { SourceSurveyDialogContent } from './content/source-survey-dialog-content';
import { SourceSurveyDialogAction } from './action/source-survey-dialog-action';

export const SourceSurveyDialog: React.FC = observer(() => {
    const { t } = useTranslation();
    const { sourceSurveyStore } = useRootStore();

    return (
        <BaseDialog
            opened={sourceSurveyStore.isOpened}
            showCloseButton={false}
            action={
                <SourceSurveyDialogAction
                    onContinue={() => {
                        sourceSurveyStore.updateSourceSurvey();
                    }}
                />
            }
            title={t(`dialogs.sourceSurvey.title`)}
            content={<SourceSurveyDialogContent />}
            width={46}
        />
    );
});
